import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { MainLayout } from "./components/layout/MainLayout";
import { Toaster } from "./components/ui/sonner";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { RouteSeo } from "./components/Seo";
import { DataCacheProvider } from "./contexts/DataCacheContext";

import { Auth } from "./pages/Auth";
import { Dashboard } from "./pages/Dashboard";
import { Tasks } from "./pages/Tasks";
import { Notes } from "./pages/Notes";
import { Budget } from "./pages/Budget";
import { FocusTimer } from "./pages/FocusTimer";
import { Achievements } from "./pages/Achievements";
import { Settings } from "./pages/Settings";

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading && !isAuthenticated) {
    return (
      <div className="min-h-screen bg-background animate-in fade-in duration-200" />
    );
  }

  return !isAuthenticated ? children : <Navigate to="/dashboard" replace />;
};

function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PublicRoute>
            <Auth />
          </PublicRoute>
        }
      />
      <Route element={<MainLayout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/notes" element={<Notes />} />
        <Route path="/budget" element={<Budget />} />
        <Route path="/focus" element={<FocusTimer />} />
        <Route path="/achievements" element={<Achievements />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <RouteSeo />
      <AuthProvider>
        <DataCacheProvider>
          <ErrorBoundary>
            <AppRoutes />
          </ErrorBoundary>
        </DataCacheProvider>
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
